module.exports = __webpack_public_path__ + "530650885edcd2b996800db65d58d494.svg";